<template>
  <v-flex>
    <v-expansion-panel expand v-model="taskDetailsPanel">
      <v-expansion-panel-content
        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
      >
        <template slot="header">
          <div class="body-2">
            <v-icon class="pr-3">mdi-page-layout-header</v-icon>
            Technical Details
          </div>
        </template>
        <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
          <v-card-text>
            <v-layout class="row wrap">
              <v-flex d-flex xs12 class="beez-padding">
                <v-card style="border-radius: 10px" flat>
                  <v-flex xs12 class="beez-padding">
                    <v-layout row wrap class="beez-padding">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Task Identifier</div>
                              <div class="subheading">{{ taskId }}</div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Name</div>
                              <div class="subheading">
                                {{ task.name }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Description</div>
                              <div class="subheading">
                                {{ task.description }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Owner</div>
                              <div class="subheading">
                                {{ task.owner }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Created At</div>
                              <div class="subheading">
                                {{ task.createdAtLocal }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Priority</div>
                              <div class="subheading">
                                {{ task.priority }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Raised by</div>
                              <div class="subheading">
                                {{ taskExecution.raisedBy }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Requested by (External)</div>
                              <div class="subheading">
                                {{
                                  taskExecution.externalRequestedBy ||
                                    'Not maintained'
                                }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="taskExecution.workflowHexId">
                          <v-flex xs12 fill-height>
                            <v-layout row wrap>
                              <v-flex xs12 md6>
                                <v-layout row wrap>
                                  <v-flex xs8>
                                    <div class="text-xs-left">
                                      <br />
                                      <div>
                                        Workflow Identifier
                                      </div>
                                      <div class="subheading">
                                        {{ taskExecution.workflowHexId }}
                                      </div>
                                      <br />
                                    </div>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-btn
                                      :outline="$vuetify.dark"
                                      icon
                                      class="ma-4"
                                      flat
                                      @click="
                                        openWorkflow(
                                          taskExecution.workflowHexId
                                        )
                                      "
                                    >
                                      <v-icon>link</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 md6>
                                <v-layout row wrap>
                                  <v-flex xs8>
                                    <div class="text-xs-left">
                                      <br />
                                      <div>
                                        Execution Identifier
                                      </div>
                                      <div class="subheading">
                                        {{ taskExecution.executionHexId }}
                                      </div>
                                      <br />
                                    </div>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-btn
                                      :outline="$vuetify.dark"
                                      icon
                                      flat
                                      class="ma-4"
                                      @click="
                                        openExecution(
                                          taskExecution.executionHexId
                                        )
                                      "
                                    >
                                      <v-icon>link</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex d-flex xs12 md6 lg4>
                            <v-layout row wrap>
                              <v-flex xs2>
                                <v-avatar tile>
                                  <v-icon class="secondary--text" medium
                                    >notification_important
                                  </v-icon>
                                </v-avatar>
                              </v-flex>
                              <v-flex xs6>
                                <div class="text-xs-left">
                                  <div>Set Due date</div>
                                  <div class="subheading">
                                    {{ delta.dueDate || task.dueLocal }}
                                  </div>
                                </div>
                              </v-flex>
                              <v-flex xs4>
                                <div
                                  class="text-xs-left"
                                  v-if="update.dueDateChange"
                                >
                                  <v-btn
                                    flat
                                    icon
                                    @click="update.dueDateChange = false"
                                    v-if="can('TASK_EDIT_DUE_DATE')"
                                  >
                                    <v-icon>
                                      edit
                                    </v-icon>
                                  </v-btn>
                                </div>
                                <div class="text-xs-left" v-else>
                                  <v-layout row wrap>
                                    <v-flex xs4>
                                      <date-time-picker
                                        @submit="setDueDate"
                                      ></date-time-picker>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="updateTask(task)"
                                      >
                                        <v-icon>
                                          save
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="
                                          delta.dueDate = null
                                          update.dueDateChange = true
                                        "
                                      >
                                        <v-icon>
                                          clear
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex d-flex xs12 md6 lg4>
                            <v-layout row wrap>
                              <v-flex xs2>
                                <v-avatar tile>
                                  <v-icon class="secondary--text" medium
                                    >event
                                  </v-icon>
                                </v-avatar>
                              </v-flex>
                              <v-flex xs6>
                                <div class="text-xs-left">
                                  <div>Set follow-up date</div>
                                  <div class="subheading">
                                    {{
                                      delta.followupDate || task.followUpLocal
                                    }}
                                  </div>
                                </div>
                              </v-flex>
                              <v-flex xs4>
                                <div
                                  class="text-xs-left"
                                  v-if="update.followUpDateChange"
                                >
                                  <v-btn
                                    flat
                                    icon
                                    @click="update.followUpDateChange = false"
                                    v-if="can('TASK_DATE_FOLLOWUP')"
                                  >
                                    <v-icon>
                                      edit
                                    </v-icon>
                                  </v-btn>
                                </div>
                                <div class="text-xs-left" v-else>
                                  <v-layout row wrap>
                                    <v-flex xs4>
                                      <date-time-picker
                                        @submit="setFollowUpDate"
                                      ></date-time-picker>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="updateTask(task)"
                                      >
                                        <v-icon>
                                          save
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="
                                          delta.followupDate = null
                                          update.followUpDateChange = true
                                        "
                                      >
                                        <v-icon>
                                          clear
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!--        Task Form -->
    <div>
      <div>
        <v-progress-linear
          color="accent"
          :indeterminate="true"
          v-if="taskFormLoader"
        ></v-progress-linear>
        <div
          v-if="
            taskExecution.proposals &&
              Array.isArray(taskExecution.proposals) &&
              taskExecution.proposals.length > 0
          "
        >
          <v-flex xs12>
            <proposal-renderer
              :proposals="taskExecution.proposals"
              :readonly="taskType !== 'claimed'"
              :cancel="false"
              @submit="executeAutomation"
              :submit-loader="taskCompleteLoader"
              submit-title="Submit Task"
            >
            </proposal-renderer>
          </v-flex>
        </div>
        <v-card
          flat
          v-else
          style="border-radius: 0px 0px 10px 10px"
          class="pa-3"
        >
          <v-alert
            style="border-radius: 10px"
            :value="true"
            color="info"
            icon="info"
            outline
          >
            Task form not available for this task, Kindly Approve or Reject the
            Task
          </v-alert>
        </v-card>
      </div>
    </div>

    <v-dialog
      v-if="confirmTaskItemDialog"
      v-model="confirmTaskItemDialog"
      max-width="500px"
    >
      <v-card style="border-radius:10px">
        <v-card-text>
          Task Selected: <b>{{ task.name }}</b> created on
          {{ task.createdAtLocal }} <br />
          Confirm to complete task?
          <b
            >(The Task Items will be Approved or Rejected based on the option
            chosen)</b
          >
        </v-card-text>
        <v-textarea
          v-model="remarks"
          hint="Please enter the approver remarks (minimum of 2 characters)"
          label="Remarks"
          class="px-3"
          outline
        >
        </v-textarea>
        <file-input
          :options="attachmentOptions"
          @filepick="updateFileLink"
        ></file-input>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="mt-2 text-capitalize"
            outline
            :loading="approveRejectLoader"
            @click.stop="confirmTaskItemDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            flat
            class="mt-2 text-capitalize primary"
            outline
            :disabled="checkRemarks"
            :loading="approveRejectLoader"
            @click.stop="handleTaskItemDialog()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<script>
import DateTimePicker from '../common/DateTimePicker'
import ProposalRenderer from '../common/ProposalRenderer'
import moment from 'moment'
import FileInput from '@/components/common/form-generator/FileInput'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'TaskDetails',
  components: { DateTimePicker, ProposalRenderer, FileInput },
  props: {
    task: {},
    taskId: String,
    taskType: {}
  },
  data() {
    return {
      remarks: '',
      attachmentOptions: {
        name: 'fileinput',
        acceptFormats: '',
        multiple: 'true'
      },
      fileAttachments: [],
      approveRejectLoader: false,
      taskFormLoader: false,
      taskCompleteLoader: false,
      update: {
        dueDateChange: true,
        followUpDateChange: true
      },
      delta: {
        dueDate: null,
        followupDate: null
      },
      taskDetailsPanel: [false],
      taskAssignmentLoader: false,
      createdByMenu: null,
      selectedAssignee: null,
      dueDateMenu: null,
      setDueDateMenu: false,
      setFollowUpDateMenu: null,
      taskExecutionDialog: false,
      confirmTaskItemDialog: false
    }
  },
  computed: {
    ...mapState({
      taskExecution: state => state.tasks.execution,
      user: state => state.session.user,
      honeyUsers: state => state.honeyUsers.honeyUsers,
      taskCandidateUsers: state => state.tasks.taskCandidateUsers
    }),
    ...mapGetters({
      can: 'can'
    }),
    checkRemarks() {
      return this.remarks.length < 2
    }
  },
  mounted() {
    this.setTaskDetails()
  },
  methods: {
    async handleTaskItemDialog() {
      this.approveRejectLoader = true
      await this.completeTaskAction(this.task, this.itemTaskModel)
      this.confirmTaskItemDialog = false
      this.approveRejectLoader = false
      this.notifyTaskListRefresh()
    },
    async completeTaskAction(task, model) {
      let body = {}
      body.taskId = this.task.id
      body.remarks = this.remarks
      body.fileAttachment = this.fileAttachments
      body.formModel = model
      this.taskCompleteLoader = true
      try {
        await this.$store.dispatch('completeTask', {
          id: this.task.id,
          body: body
        })
        setTimeout(function() {
          //Wait for 3 seconds for task completion
        }, 3000)
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Task has been Completed',
          description: 'User Task Completed Successfully',
          type: 'success'
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to complete the Task',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskCompleteLoader = false
      if (this.taskAction) await this.$router.replace({ name: 'tasks' }).catch()
    },
    updateFileLink: function(link) {
      this.fileAttachments = link
    },
    executeAutomation(model) {
      this.itemTaskModel = model
      this.confirmTaskItemDialog = true
    },
    openWorkflow(workflowId) {
      this.$router
        .push({
          name: 'workflow-detail',
          params: { hexId: workflowId }
        })
        .catch()
    },
    openExecution(executionId) {
      this.$router
        .push({ name: 'executions', query: { search: executionId } })
        .catch()
    },
    async updateTask(item) {
      let localItem = {}
      localItem.id = item.id
      if (this.delta.dueDate) {
        localItem.due = moment(
          this.delta.dueDate,
          'MMMM Do YYYY, h:mm:ss a'
        ).format('YYYY-MM-DDTHH:mm:ss.SSSZZ')
      }
      if (this.delta.followupDate) {
        localItem.followUp = moment(
          this.delta.followupDate,
          'MMMM Do YYYY, h:mm:ss a'
        ).format('YYYY-MM-DDTHH:mm:ss.SSSZZ')
      }
      try {
        await this.$store.dispatch('saveTask', localItem)
        this.delta.dueDate = null
        this.delta.followupDate = null
        this.update.dueDateChange = true
        this.update.followUpDateChange = true
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Task has been Saved',
          description: 'User Task saved Successfully',
          type: 'success'
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Cannot update task!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }

      try {
        await this.$store.dispatch('replicateTask', item.hexId)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Cannot replicate task!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      await this.setTaskDetails()
      this.notifyTaskListRefresh()
    },
    notifyTaskListRefresh() {
      this.$emit('task-refresh')
    },
    setTaskDetails: async function() {
      this.delta.dueDate = null
      this.delta.followupDate = null
      this.taskFormLoader = true
      await this.getExecution()
      this.taskFormLoader = false
    },
    async getExecution() {
      await this.$store.dispatch('fetchTaskExecution', this.task).catch(err => {
        console.log(err)
        this.taskFormLoader = false
      })
    },
    setFollowUpDate(dateTime) {
      this.delta.followupDate = moment(dateTime).format(
        'MMMM Do YYYY, h:mm:ss a'
      )
    },
    setDueDate(dateTime) {
      this.delta.dueDate = moment(dateTime).format('MMMM Do YYYY, h:mm:ss a')
    }
  }
}
</script>
